import React, { ChangeEvent } from "react";
import IOrder_Progress_State from "../../../../models/IOrder_Progress_State";
import OwLabel from "../../../shared/OwLabel/OwLabel";

type Props = {
    selectedOrderStateId: number | null | undefined;
    orderProgressStates: IOrder_Progress_State[];
    onChange: (orderStateId: number | null) => void;
};

const OrderStateBridgePicker: React.FC<Props> = ({ selectedOrderStateId, orderProgressStates, onChange }) => {
    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const val = e.target.value;
        onChange(val === "" ? null : Number(val));
    };

    return (
        <div className="OrderStateBridgePicker mb-3">
            <OwLabel title={"on_completion_order_state"} leftIconClass={"fad fa-exchange-alt"} />
            <p className="text-muted small mb-2">
                <i className="fad fa-info-circle me-1" />
                When all serials on an order reach the terminal step, the order will automatically advance to the selected state. Choose
                &ldquo;(No auto-advancement)&rdquo; if you prefer to advance orders manually.
            </p>
            <select className="form-select" value={selectedOrderStateId ?? ""} onChange={handleChange} style={{ maxWidth: "20rem" }}>
                <option value="">(No auto-advancement)</option>
                {orderProgressStates.map((state) => (
                    <option key={state.order_state_id} value={state.order_state_id}>
                        {state.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default OrderStateBridgePicker;
